import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import app from './modules/app'
import role from './modules/role'
import givingCart from './modules/givingCart'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user, app, role, givingCart
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js